export default __webpack_public_path__ + "static/media/orion.01d5f6dc.png";